import { useState } from 'react';
import { motion } from 'framer-motion';

const PARTICLE_COLORS = [
  'bg-primary',
  'bg-accent',
  'bg-success',
  'bg-primary-dark',
];

const PARTICLE_COUNT = 22;

interface Particle {
  id: number;
  tx: number;
  ty: number;
  delay: number;
  color: string;
  size: number;
  rotation: number;
}

export default function Confetti() {
  const [particles] = useState<Particle[]>(() =>
    Array.from({ length: PARTICLE_COUNT }, (_, i) => {
      // Fan upward and outward: angle from -150° to -30° (top hemisphere)
      const angleDeg = -150 + (i / (PARTICLE_COUNT - 1)) * 120;
      const jitter = (Math.random() - 0.5) * 18;
      const angle = ((angleDeg + jitter) * Math.PI) / 180;
      const distance = 140 + Math.random() * 110;

      return {
        id: i,
        tx: Math.cos(angle) * distance,
        ty: Math.sin(angle) * distance,
        delay: Math.random() * 0.12,
        color: PARTICLE_COLORS[i % PARTICLE_COLORS.length],
        size: 5 + Math.random() * 3,
        rotation: (Math.random() - 0.5) * 540,
      };
    })
  );

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-50 flex items-center justify-center"
    >
      <div className="relative">
        {particles.map((p) => (
          <motion.span
            key={p.id}
            className={`absolute rounded-[2px] ${p.color}`}
            style={{
              width: p.size,
              height: p.size,
              left: -p.size / 2,
              top: -p.size / 2,
            }}
            initial={{ opacity: 0, x: 0, y: 0, rotate: 0 }}
            animate={{
              opacity: [0, 1, 1, 0],
              x: [0, p.tx * 0.5, p.tx, p.tx],
              y: [0, p.ty * 0.6, p.ty, p.ty + 220],
              rotate: [0, p.rotation],
            }}
            transition={{
              duration: 1.5,
              delay: p.delay,
              ease: [0.22, 1, 0.36, 1],
              times: [0, 0.15, 0.6, 1],
            }}
          />
        ))}
      </div>
    </div>
  );
}
